import ReactApexChart from "react-apexcharts";

export default function LeadTaskChart({ labels, values, colors, total }) {
  return (
    <ReactApexChart
      type="donut"
      height={240}
      series={values}
      options={{
        chart: {
          type: "donut",
          height: 240,
          fontFamily: "'Outfit', sans-serif",
        },
        labels,
        colors,
        plotOptions: {
          pie: {
            donut: {
              size: "62%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#6b7280",
                  formatter: () => total,
                },
              },
            },
          },
        },
        dataLabels: { enabled: false },
        legend: {
          position: "right",
          fontSize: "12px",
          markers: { radius: 3 },
        },
        stroke: { width: 2, colors: ["#ffffff"] },
        tooltip: { theme: "light" },
      }}
    />
  );
}
